// 着座→獲得率の分母「有効着座」（ADR 0028）。
//
// 有効着座 = 着座 − 「有効じゃない」と記録された着座。サーバが valid_seat として返す。
// 表示する「着座」の件数は変えず、獲得率の分母だけをこれにする。
// 計算はサーバ（worker/src/seat-rate.mjs）が持ち、画面は受け取った値を使うだけにする。

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/** 着座→獲得率の分母。valid_seat が無い（古いサーバの応答など）ときは seat に戻す。 */
export function acqDenominator(row) {
  if (!row) return 0;
  return row.valid_seat != null ? num(row.valid_seat) : num(row.seat);
}

/** 率の分母から外した件数（＝「有効じゃない」）。注記を出すかの判定に使う。 */
export function invalidSeatCount(row) {
  if (!row || row.valid_seat == null) return 0;
  return Math.max(0, num(row.seat) - num(row.valid_seat));
}

/** 時間帯ごとの行から有効着座を合計する（時間別入力・日報の本人合計用）。 */
export function sumValidSeat(rows) {
  return (rows || []).reduce((s, r) => s + acqDenominator(r), 0);
}
